import { CustomDialog } from "../../../../../../../../../components/dialog/v1/CustomDialog";
import styled from 'styled-components';
import { useApiInfoContextValueHook } from "../../../../../../../../../contexts/ApiInfoContext";
import { useEffect, useState } from "react";
import { SellertoolSignatureUtils } from "../../../../../../../../../utils/sellertool-signature-utils";
import { CustomBackdropController } from "../../../../../../../../../components/backdrop/default/v1";
import { ProductOptionsApi } from "../../../../../../../../../apis/ProductOptionsApi";
import { CustomLabelInput } from "../../../../../../../../../components/input/CustomLabelInput";
import CustomBlockButton from "../../../../../../../../../components/button/CustomBlockButton";
import { v4 as uuidv4 } from 'uuid';
import { InventoryReceivesApi } from "../../../../../../../../../apis/InventoryReceivesApi";
import { useFetcher } from "../../../../../../fetcher/useFetcher";
const StyledHeader = styled.div`
    padding: 10px;
`;

const StyledBody = styled.div`
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    .label{
        font-size: 14px;
        font-weight: 600;
        color: #333;
    }

    .content{
        font-size: 14px;
        font-weight: 500;
        color: #333;
        padding-left: 5px;
        margin-top: 5px;
    }

    input{
        border-radius: 3px;
        border: 1px solid #e0e0e0;
    }
`;

const StyledFooter = styled.div`
    padding: 10px;

    button{
        border-radius: 3px;
        background-color: #333;
        color: #fff;
        font-weight: 600;
        border:none;
    }
`;


export function ModalCancel({
    open,
    onClose,
    returnExchange
}) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();
    const fetcher = useFetcher();

    const handleSubmit = async () => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        const body = {
            formDatas: [returnExchange?._id]
        }

        CustomBackdropController().showBackdrop();
        const response = await InventoryReceivesApi().cancelList({ headers: headers, body: body });

        if (response?.content) {
            fetcher.fetchReturnExchanges();
            onClose();
        }
        CustomBackdropController().hideBackdrop();
    }
    return (
        <>
            <CustomDialog
                open={open}
                onClose={() => onClose()}
            >
                <StyledHeader>
                    <CustomDialog.Header>
                        <CustomDialog.Header.Fake />
                        <CustomDialog.Header.Title>
                            입고반영 취소
                        </CustomDialog.Header.Title>
                        <CustomDialog.Header.Close onClick={() => onClose()} />
                    </CustomDialog.Header>
                </StyledHeader>
                <StyledBody>
                    입고반영을 취소합니다.
                </StyledBody>
                <StyledFooter>
                    <CustomBlockButton
                        type='button'
                        onClick={() => handleSubmit()}
                    >
                        입고반영 취소
                    </CustomBlockButton>
                </StyledFooter>
            </CustomDialog>
        </>
    );
}